module.exports = __webpack_public_path__ + "eefa6ef1985c35f02a3bae693f8b84a2.png";